import styled from 'styled-components';
import { Breakpoints } from '../../../styled/constants';

export const CurrentItemPhotosContainer = styled.div`
  position: relative;

  @media screen and (min-width: ${Breakpoints.tablet}px) {
    margin: 0 40px;
  }

  @media screen and (min-width: ${Breakpoints.smallDesktop}px) {
    margin: 0;
  }
`;
